import Bugsnag from "@bugsnag/js"
import BugsnagPluginReact from "@bugsnag/plugin-react"
import PropTypes from "prop-types"
import React from "react"
import { QueryClient, QueryClientProvider } from "react-query"
import { ReactQueryDevtools } from "react-query/devtools"
import { MarinaProvider } from "src/contexts/MarinaContext"
import { BarcodeScannerProvider } from "src/providers/BarcodeScannerProvider"

import ErrorBoundaryProvider from "src/components/ErrorBoundaryProvider"
import ToastContainer from "src/components/Toast/ToastContainer"
import { ToastProvider } from "src/components/Toast/ToastContext"

// Initialize Bugsnag if settings are available
if (window.bugsnagSettings) {
  Bugsnag.start({
    ...window.bugsnagSettings,
    plugins: [new BugsnagPluginReact()],
  })
}

// Create a singleton query client
const queryClient = new QueryClient()

/**
 * Wrapper component that provides all necessary context providers for React on Rails components
 * This mirrors the provider setup from react-automounter.js
 */
const ReactOnRailsProviderWrapper = ({
  children,
  showReactQueryDevtools = true,
}) => {
  return (
    <ErrorBoundaryProvider>
      <MarinaProvider>
        <ToastProvider>
          <BarcodeScannerProvider>
            <QueryClientProvider client={queryClient}>
              {children}
              <div className="relative flex justify-center">
                <ToastContainer />
              </div>
              {showReactQueryDevtools && (
                <ReactQueryDevtools position="bottom-right" />
              )}
            </QueryClientProvider>
          </BarcodeScannerProvider>
        </ToastProvider>
      </MarinaProvider>
    </ErrorBoundaryProvider>
  )
}

ReactOnRailsProviderWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  showReactQueryDevtools: PropTypes.bool,
}

export default ReactOnRailsProviderWrapper
